import { render, staticRenderFns } from "./CourseExam.vue?vue&type=template&id=1481a22d&scoped=true"
import script from "./CourseExam.vue?vue&type=script&lang=js"
export * from "./CourseExam.vue?vue&type=script&lang=js"
import style0 from "./CourseExam.vue?vue&type=style&index=0&id=1481a22d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481a22d",
  null
  
)

export default component.exports